import React from 'react';
import styles from '../Profile.module.css';

const warningMarkIconUrl = `${process.env.PUBLIC_URL}/icons/warning_mark.svg`;

const ProfileWarningIcon: React.FC = () => {
  const [useInlineFallback, setUseInlineFallback] = React.useState(false);

  return (
    <div className={styles.profileStateIcon} aria-hidden="true">
      {useInlineFallback ? (
        <svg
          className={styles.profileStateIconGlyph}
          viewBox="0 0 24 24"
          focusable="false"
        >
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 6v8m.05 4v.1h-.1V18z"
          />
        </svg>
      ) : (
        <img
          className={styles.profileStateIconGlyph}
          src={warningMarkIconUrl}
          alt=""
          onError={() => setUseInlineFallback(true)}
        />
      )}
    </div>
  );
};

export default ProfileWarningIcon;
